import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import colours from 'styles/colours';
import {selectApplication} from 'modules/applications/actions';
import {renderApplicationPath} from 'paths';

const buttonStyles = ({active, focused}) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '14px 20px 14px 21px',
    background: active ? colours.background.listRow.hover : colours.background.listRow.normal,
    border: 'none',
    borderBottom: `1px solid ${colours.border.rowDivider}`,
    borderLeft: active ? `3px solid ${colours.border.primary.highlight}` : '3px solid transparent',
    cursor: 'pointer',
    textAlign: 'left',
    fontSize: 14,
    fontWeight: 500,
    color: colours.font.bodyStrong,
    fontFamily: 'inherit',
    letterSpacing: '0.01em',
    transition: 'background 0.15s ease, border-color 0.15s ease, padding-left 0.15s ease, transform 0.15s ease',
    boxSizing: 'border-box',
    outline: focused ? `2px solid ${colours.border.primary.highlight}` : 'none',
    outlineOffset: focused ? '-2px' : '0',
    textDecoration: 'none',
});

export default function AppItem({app, onClose}) {
    const dispatch = useDispatch();
    const [hovered, setHovered] = useState(false);
    const [focused, setFocused] = useState(false);
    const active = hovered || focused;

    const isExternal = app.type === 'external';
    const href = isExternal ? app.link : renderApplicationPath(app.slug);

    const handleClick = (e) => {
        // For external links, keep default anchor behavior (incl. target=_blank),
        // but still close the panel.
        if (isExternal) {
            onClose();
            return;
        }

        // Let the browser handle modifier/middle clicks (new tab/window).
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
            return;
        }

        e.preventDefault();
        dispatch(selectApplication(app.id));
        onClose();
    };

    return (
        <a
            href={href}
            target={isExternal ? '_blank' : undefined}
            rel={isExternal ? 'noopener noreferrer' : undefined}
            onClick={handleClick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            style={buttonStyles({active, focused})}
        >
            <span style={{flex: 1}}>{app.name}</span>
        </a>
    );
}

